import React, { useState } from 'react'
import SmoothCollapse from 'react-smooth-collapse'
import { IFaqEntry } from 'shared/interfaces/i-api-faq'
import dompurify from 'dompurify'

interface IAccordion {
	question: IFaqEntry
}

function setTargetForAnchors(html: string) {
	let answer = html.trim()
	let temp = document.createElement('div')
	temp.innerHTML = answer
	let childList = temp.getElementsByTagName('a')
	for (var i = 0; i < childList.length; i++)
		childList[i].setAttribute('target', '_blank')

	return { __html: temp.innerHTML }
}

const AccordionItem = ({ question }: IAccordion) => {
	const sanitizer = dompurify.sanitize
	const [open, setOpen] = useState<boolean>(false)
	const nestedQuestions = (question.children || []).map(
		(question: IFaqEntry) => {
			return <AccordionItem key={question.rowKey} question={question} />
		}
	)

	let crossCls = open ? 'cross-icon open' : 'cross-icon'

	return (
		<div className="accordion-item outer-container py-3 mb-4 pointer">
			<div
				className="d-flex justify-content-between"
				onClick={() => setOpen(!open)}>
				<span className="text">{question.question}</span>
				<span className={crossCls.toString()}></span>
			</div>
			<SmoothCollapse
				expanded={open}
				children={
					<div className="pt-3 nested-item">
						{question.answer ? (
							<div
								dangerouslySetInnerHTML={setTargetForAnchors(
									sanitizer(question.answer)
								)}
							/>
						) : (
							<>{nestedQuestions}</>
						)}
					</div>
				}
				allowOverflowWhenOpen={true}
			/>
		</div>
	)
}
export default AccordionItem
